export default __webpack_public_path__ + "static/media/dont_circle.95884be7.png";